import React from 'react'
import { Color } from '../../../types/Color'
import IconButton from '../../../components/IconButton'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import cx from 'classnames'
import styles from '../ColorsManagement.module.css'

type ColorListProps = {
    colors: Color[]
    onDelete: (colorId: number) => void
}

const ColorListView: React.FC<ColorListProps> = ({
    colors,
    onDelete,
}) => {
    return (
        <div className={cx(styles['colors-grid-container'])}>
            {colors.map((colorItem) => (
                <div 
                    key={colorItem.id} 
                    className={cx(styles['color-grid-item'])}
                >
                    <div className={cx(styles['color-grid-preview'])}>
                        <div
                            className={cx(styles['color-preview-small'])}
                            style={{ backgroundColor: colorItem.color }}
                        />
                        <IconButton
                            icon={faTrashAlt}
                            color="#ffffff"
                            title="Löschen"
                            onClick={() => onDelete(colorItem.id)}
                            classes={styles['color-delete-button']}
                        />
                    </div>
                    <div className={cx(styles['color-grid-info'])}>
                        <div className={cx(styles['color-grid-name'])}>
                            {colorItem.name}
                        </div>
                        <div className={cx(styles['color-grid-hex'])}>
                            {colorItem.color}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default ColorListView
